import { render, staticRenderFns } from "./issue-codification.vue?vue&type=template&id=c00daaf4"
import script from "./issue-codification.vue?vue&type=script&lang=js"
export * from "./issue-codification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports